'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_OperationalAppRegisteredUser$GeneralPractice$$anon$1() {
}
export { $c_Lapp_data_OperationalAppRegisteredUser$GeneralPractice$$anon$1 as $c_Lapp_data_OperationalAppRegisteredUser$GeneralPractice$$anon$1 };
$c_Lapp_data_OperationalAppRegisteredUser$GeneralPractice$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractPartialFunction();
$c_Lapp_data_OperationalAppRegisteredUser$GeneralPractice$$anon$1.prototype.constructor = $c_Lapp_data_OperationalAppRegisteredUser$GeneralPractice$$anon$1;
/** @constructor */
function $h_Lapp_data_OperationalAppRegisteredUser$GeneralPractice$$anon$1() {
}
export { $h_Lapp_data_OperationalAppRegisteredUser$GeneralPractice$$anon$1 as $h_Lapp_data_OperationalAppRegisteredUser$GeneralPractice$$anon$1 };
$h_Lapp_data_OperationalAppRegisteredUser$GeneralPractice$$anon$1.prototype = $c_Lapp_data_OperationalAppRegisteredUser$GeneralPractice$$anon$1.prototype;
$c_Lapp_data_OperationalAppRegisteredUser$GeneralPractice$$anon$1.prototype.isDefinedAt__T2__Z = (function(x) {
  if ((x !== null)) {
    x._1__O();
    var involvement = x._2__O();
    if (involvement.Lapp_data_GeneralPracticeInvolvement__f_status.isOperational__Z()) {
      return true;
    }
  }
  return false;
});
$c_Lapp_data_OperationalAppRegisteredUser$GeneralPractice$$anon$1.prototype.applyOrElse__T2__F1__O = (function(x, default$1) {
  if ((x !== null)) {
    var id = x._1__O();
    var involvement = x._2__O();
    if (involvement.Lapp_data_GeneralPracticeInvolvement__f_status.isOperational__Z()) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), id, involvement);
    }
  }
  return default$1.apply__O__O(x);
});
$c_Lapp_data_OperationalAppRegisteredUser$GeneralPractice$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__T2__Z(x);
});
$c_Lapp_data_OperationalAppRegisteredUser$GeneralPractice$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__T2__F1__O(x, default$1);
});
var $d_Lapp_data_OperationalAppRegisteredUser$GeneralPractice$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_OperationalAppRegisteredUser$GeneralPractice$$anon$1, "app.data.OperationalAppRegisteredUser$GeneralPractice$$anon$1", ({
  Lapp_data_OperationalAppRegisteredUser$GeneralPractice$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_data_OperationalAppRegisteredUser$GeneralPractice$$anon$1 as $d_Lapp_data_OperationalAppRegisteredUser$GeneralPractice$$anon$1 };
//# sourceMappingURL=app.data.-Operational-App-Registered-User$-General-Practice$$anon$1.js.map
